import React from 'react';

const translations = {
  en: {
    error: "Error!",
  },
  nl: {
    error: "Fout!",
  }
};

const Error = ({error, isDutch}) => {
    const t = translations[isDutch ? 'nl' : 'en'];
    
    return(
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
                <strong className="font-bold">{t.error}</strong>
                <span className="block sm:inline"> {error}</span>
            </div>
    )
};

export default Error; 
